<template>
  <div class="main">
    <div class="content">
      <h2 style="text-align: center">用户注册</h2>
      <el-steps :active="active" finish-status="success">
        <el-step title="企业基本信息">
        </el-step>
        <el-step title="企业法定代表人信息">
        </el-step>
        <el-step title="联系人信息">
        </el-step>
        <el-step title="账户信息">
        </el-step>
      </el-steps>
      <div style="height: 40px"></div>
      <el-form v-if="active===0" :inline="false" :model="baseForm" label-width="140px" :rules="dataRules" ref="baseForm"
               :size="size">

        <el-row>
          <el-col :span="10">
            <el-form-item label="绑定CA" prop="caCode">
              <el-input v-model="baseForm.caCode" auto-complete="off" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-button type="primary" style="margin-top: 1px;margin-left: 2px" :size="size" @click="bindCA">绑定CA
            </el-button>
            <span class="regTip">请绑定法人一证通数字证书，且此证书将作为主证书使用</span>
          </el-col>
        </el-row>
        <base-info :formData="baseForm" :fileConfig="fileConfig" @changeFileType="changeFileType" sourceModel="register" :show-log="false"
                   ref="baseInfo"></base-info>
        <div class="operations">
          <el-button style="margin-top: 12px;" @click="cancel">{{ $t('action.cancel') }}</el-button>
          <el-button type="primary" style="margin-top: 12px;" @click="next('baseForm')">{{ $t('action.next') }}
          </el-button>
        </div>
      </el-form>
      <el-form v-if="active===1" :inline="false" :model="frForm" label-width="140px" :rules="dataRules" ref="frForm"
               :size="size">
        <legal-person :form-data="frForm"></legal-person>
        <div class="operations">
          <el-button style="margin-top: 12px;" @click="last">上一步</el-button>
          <el-button type="primary" style="margin-top: 12px;" @click="next('frForm')">下一步</el-button>
        </div>
      </el-form>
      <el-form v-if="active===2" :inline="false" :model="lxrForm" label-width="140px" :rules="dataRules" ref="lxrForm"
               :size="size">
        <contact-person :form-data="lxrForm"></contact-person>
        <div class="operations">
          <el-button style="margin-top: 12px;" @click="last">{{ $t('action.last') }}</el-button>
          <el-button type="primary" style="margin-top: 12px;" @click="next('lxrForm')">{{ $t('action.next') }}
          </el-button>
        </div>
      </el-form>

      <el-form v-if="active===3" :inline="false" :model="accountForm" label-width="140px" :rules="dataRules"
               ref="accountForm"
               :size="size">
        <el-row>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="登录账号" prop="loginName">
              <el-input v-model="accountForm.loginName" maxlength="20" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="登录密码" prop="password">
              <el-input type="password" v-model="accountForm.password" maxlength="20" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="确认登录密码" prop="confirmPassword">
              <el-input type="password" v-model="accountForm.confirmPassword" maxlength="20"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
        </el-row>
        <div class="operations">
          <el-button style="margin-top: 12px;" @click="last">{{ $t('action.last') }}
          </el-button>
          <el-button type="primary" @click.native="submitForm" :loading="editLoading">
            马上注册
          </el-button>
        </div>
      </el-form>
    </div>
    <el-dialog
      title="请输入密码"
      :visible.sync="passwordDlgVisible"
      width="500px"
      :show-close="false"
      @close="passowrd=''"
    >
      <el-input type="password" v-model="passowrd"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="passwordDlgVisible=false">取 消</el-button>
    <el-button type="primary" @click="btnOkClick(passowrd)">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>


import BaseInfo from '@/views/Member/BaseInfo';
import LegalPerson from '@/views/Member/LegalPerson';
import ContactPerson from '@/views/Member/ContactPerson';
import {CA} from '@/utils/cert';
import Cookies from 'js-cookie';
import {buildEntitesIndexX, getRegiestMajorEntities} from '../utils/entities';

export default {
  components: {ContactPerson, LegalPerson, BaseInfo},
  data() {
    let regiestMajor = getRegiestMajorEntities();
    buildEntitesIndexX(regiestMajor, 'value');
    var checkConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认登录密码'));
      } else if (value !== this.accountForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    this.getFileConfig();
    return {
      regiestMajor: regiestMajor,
      fileConfigList: [],
      fileConfig: [],
      passwordDlgVisible: false,
      passowrd: null,
      active: 0,
      editLoading: false,
      size: 'small',
      dataRules: {
        caCode: [
          {required: true, message: '请绑定法人一证通数字证书', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择机构类型', trigger: 'change'},
        ],
        tyshxydm: [
          {required: true, message: '请输入统一社会信用代码', trigger: 'blur'},
        ],
        areas: [
          {required: true, message: '请选择机构所在地', trigger: 'change'},
        ],
        address: [
          {required: true, message: '请输入注册地址', trigger: 'blur'},
        ],
        workAddress: [
          {required: true, message: '请输入办公地址', trigger: 'blur'},
        ],
        establishDate: [
          {required: true, message: '请选择成立日期', trigger: 'change'},
        ],
        djzclx: [
          {required: true, message: '请选择登记注册类型', trigger: 'change'},
        ],
        zczb: [
          {required: true, message: '请输入注册资本', trigger: 'blur'},
          {
            pattern: /^(-)?\d*\.?\d{0,4}$/,
            message: '请输入最多保留4位小数的有效数字',
            trigger: 'blur',
          },
        ],
        legalPersonName: [
          {required: true, message: '请输入法定代表人姓名', trigger: 'blur'},
        ],

        legalPersonDuty: [
          {required: true, message: '请输入法定代表人职务', trigger: 'blur'},
        ],
        legalPersonOfficeTel: [
          {required: true, message: '请输入法定代表人联系电话', trigger: 'blur'},
          {
            pattern: /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
            message: '电话号码格式不正确，请重新输入',
            trigger: 'blur',
          },
        ],
        legalPersonSex: [
          {required: true, message: '请输入法定代表人性别', trigger: 'click'},
        ],
        legalPersonIdcardNo: [
          {required: true, message: '请输入法定代表人身份证号码', trigger: 'blur'},
          /*{
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '格式不正确，请重新输入（15或18位）',
            trigger: 'blur'
          }*/

        ],
        legalPersonMobile: [
          {required: true, message: '请输入法定代表人手机号', trigger: 'blur'},
          {
            pattern: /^1[345789]\d{9}$/,
            message: '手机号格式不正确，请重新输入',
            trigger: 'blur',
          },
        ],
        contactPersonName: [
          {required: true, message: '请输入联系人姓名', trigger: 'blur'},
        ],
        contactPersonDuty: [
          {required: true, message: '请输入联系人职务', trigger: 'blur'},
        ],
        contactPersonSex: [
          {required: true, message: '请输入联系人性别', trigger: 'click'},
        ],
        contactPersonIdcardNo: [
          {required: true, message: '请输入联系人身份证号码', trigger: 'blur'},
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '格式不正确，请重新输入（15或18位）',
            trigger: 'blur',
          },

        ],
        contactPersonOfficeTel: [
          {required: true, message: '请输入联系人联系电话', trigger: 'blur'},
          {
            pattern: /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
            message: '电话号码格式不正确，请重新输入',
            trigger: 'blur',
          },
        ],
        contactPersonMobile: [
          {required: true, message: '请输入联系人手机号', trigger: 'blur'},
          {
            pattern: /^1[345789]\d{9}$/,
            message: '手机号格式不正确，请重新输入',
            trigger: 'blur',
          },
        ],
        zyyw: [
          {required: true, message: '请输入主营业务', trigger: 'blur'},
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {
            type: 'email',//要检验的类型（number，email，date等）
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        loginName: [
          {required: true, message: '请输入登录账号', trigger: 'blur'},
          {
            pattern: /^\S+$/,
            message: '账号格式不正确，不能包含空格',
            trigger: 'blur',
          },
        ],
        password: [
          /*{required: true, message: '请输入登录密码', trigger: 'blur'},
          {
            pattern: /^(\w){6,20}$/,
            message: '密码格式不正确，请输入6-20位,字母、数字、下划线',
            trigger: 'blur',
          },*/
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,30}$/,
            message: '密码最短由8位数字,字母,特殊符号三种以及三种以上组成',
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          {validator: checkConfirmPassword, required: true, trigger: 'blur'},
        ],
        qualification: [
          {required: true, message: '请输入资质', trigger: 'blur'},
        ],
        personnel: [
          {required: true, message: '请输入人员', trigger: 'blur'},
        ],
        zipcode: [
          {required: true, message: '请输入邮政编码', trigger: 'blur'},
        ],
        zgdw: [
          {required: true, message: '请输入主管单位', trigger: 'blur'},
        ],
        fax: [
          {required: true, message: '请输入传真', trigger: 'blur'},
        ],
        jbzhkhh: [
          {required: true, message: '请选择基本开户行', trigger: 'change'},
        ],
        url: [
          {required: true, message: '请输入单位网址', trigger: 'blur'},
        ],
        jbzhkhm: [
          {required: true, message: '请输入基本账户开户名', trigger: 'blur'},
        ],
        jbzhkhzh: [
          {required: true, message: '请输入基本账户开户账号', trigger: 'blur'},
        ],
        legalPersonPoliticalStatus: [
          {required: true, message: '请输入政治面貌', trigger: 'blur'},
        ],
        regiestMajor: [
          {required: true, message: '请选择注册专业', trigger: 'change'},
        ],
        contactPersonPoliticalStatus: [
          {required: true, message: '请输入政治面貌', trigger: 'blur'},
        ],
        dwjj: [
          {
            validator: (rule, value, callback) => {
              //文件配置
              let fileConfigKey = {};
              for (let i = 0; i < this.fileConfig.length; i++) {
                let row = this.fileConfig[i];
                fileConfigKey[row.id] = row;
              }
              let aEntities = {Rows: []};
              aEntities.Rows = this.baseForm.files;
              let error = '';
              let successType = [];//已经存在的文件类型
              for (let i = 0; i < aEntities.Rows.length; i++) {
                let row = aEntities.Rows[i];
                let config = fileConfigKey[row.configId];
                if (config) {
                  successType.push(config.type);
                }
              }
              //找到哪些文件类型的文件没有上传
              for (let i = 0; i < this.fileConfig.length; i++) {
                let row = this.fileConfig[i];
                if (row.isMust) { //是必填的
                  let index = successType.indexOf(row.type);
                  if (index === -1) {
                    error += row.typeName + ',';
                  }
                }
              }
              if (error != '') {
                error = error.substr(0, error.length - 1);
                callback(new Error('请上传' + error));
                return;
              }
              callback();
            }, required: true, trigger: 'blur',
          },
        ],
        dzzxs: [],//党组织建制
        secretaryPersonName: [],//书记姓名
        secretaryPersonOfficeTel: [],//书记联系电话
        deputySecretaryPersonName: [],//副书记姓名
        deputySecretaryPersonOfficeTel: [],//副书记联系电话
      },
      baseForm: {
        caCode: null,//ca锁唯一编码
        name: null,//名称
        type: null,//机构类型
        tyshxydm: null,//统一社会信用代码
        zipcode: null,//邮政编码
        establishDate: null,//成立日期
        djzclx: null,//登记注册类型
        zczb: null,//注册资本
        zgdw: null,//主管单位
        fax: null,//传真
        email: null,//邮箱
        url: null,//单位网址
        zyyw: null,//主营业务
        dwjj: null,//单位简介
        jbzhkhh: null,//基本账户开户行
        jbzhkhm: null,//基本账户开户名
        jbzhkhzh: null,//基本账户开户账号
        areas: [],//机构所在地
        address: null,//注册地址
        regiestMajor: '1',//注册专业
        workAddress: null,//办公地址
        files: [],
        isDzzjz: false, // 党组织建制
        dzzxs: null, // 党组织形式
        dygdrs: null, // 固定党员人数
        dyldrs: null, //流动党员人数
        secretaryPersonName: null, // 书记姓名
        secretaryPersonOfficeTel: null, // 书记联系电话
        deputySecretaryPersonName: null, // 副书记姓名
        deputySecretaryPersonOfficeTel: null, // 副书记联系电话
        qualification: null,//资质
        personnel: null,// 人员
        associationDuties: '1',//协会职务--默认一般会员单位
      },
      frForm: {

        legalPersonName: null,//法人-姓名
        legalPersonDuty: null,//法人-职务
        legalPersonSex: null,//法人-性别
        legalPersonIdcardNo: null,//法人-身份证号码
        legalPersonPoliticalStatus: null,//法人-政治面貌
        legalPersonOfficeTel: null,//法人-联系电话
        legalPersonMobile: null,//法人-手机号
      },
      lxrForm: {
        contactPersonName: null,//联系人姓名
        contactPersonDuty: null,//联系人职务
        contactPersonSex: null,//联系人-性别
        contactPersonIdcardNo: null,//联系人-身份证号码
        contactPersonPoliticalStatus: null,//联系人-政治面貌
        contactPersonOfficeTel: null,//联系人联系电话
        contactPersonMobile: null,//联系人手机号
      },
      accountForm: {
        loginName: null,//账号
        password: null,//密码
        confirmPassword: null,//确认密码
      },
    };
  },
  watch: {
    'baseForm.isDzzjz'(val) {
      if (val) {
        this.dataRules.dzzxs.push({required: true, message: '请选择党组织形式', trigger: 'change'});
        this.dataRules.secretaryPersonName.push({required: true, message: '请输入书记姓名', trigger: 'blur'});
        this.dataRules.secretaryPersonOfficeTel.push({
          required: true,
          message: '请输入书记联系电话',
          trigger: 'change',
        });
        this.dataRules.deputySecretaryPersonName.push({
          required: true,
          message: '请输入副书记姓名',
          trigger: 'change',
        });
        this.dataRules.deputySecretaryPersonOfficeTel.push({
          required: true,
          message: '请输入副书记联系电话',
          trigger: 'change',
        });
      } else {
        this.dataRules.dzzxs = [];
        this.dataRules.secretaryPersonName = [];
        this.dataRules.secretaryPersonOfficeTel = [];
        this.dataRules.deputySecretaryPersonName = [];
        this.dataRules.deputySecretaryPersonOfficeTel = [];
      }
    },
  },
  methods: {
    /**
     * 查询附件配置
     */
    getFileConfig: function() {
      let params = {
        columnFilters: {
          sourceCode: 'ZC',
        },
      };
      this.$api.attach.getFileConfig(params).then((res) => {
        if (res.code === 200) {
          this.fileConfig = res.data.list;
          this.fileConfigList = res.data.list;
          //默认初始值为1
          this.changeFileType(this.regiestMajor['1'].fileType.toString());
        }
      });
      return [];
    },
    changeFileType: function(str) {
      let newFileConfig = [];
      for (let i = 0; i < this.fileConfigList.length; i++) {
        let param = this.fileConfigList[i].type;
        if (str.indexOf(param) != -1) {
          newFileConfig.push(this.fileConfigList[i]);
        }
      }
      this.fileConfig = [].concat(newFileConfig);
    },
    next(frmName) {
      this.$refs[frmName].validate((valid) => {
        if (valid) {
          if (this.active === 0) {
            if (!this.baseForm.files || this.baseForm.files.length === 0) {
              this.$message.error('请上传单位简介');
              return;
            }
            let oParams = {
              tyshxydm: this.baseForm.tyshxydm,
            };
            this.$api.deptExtend.checkDeptExtendByTyshxydm(oParams).then((res) => {
              if (res.data) {
                this.active++;
              } else {
                this.$alert('统一社会信用代码已存在', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  },
                });
              }
            });
          } else {
            this.active++;
          }
        } else {
          return false;
        }
      });
    },
    last() {
      this.active--;
      setTimeout(() => {
        if (this.active === 0 && this.$refs.baseInfo) {
          this.$refs.baseInfo.initUploadFile()
        }
      }, 500)

    },
    submitForm() {
      this.$refs['accountForm'].validate((valid) => {
        if (valid) {
          const oData = Object.assign(this.baseForm, this.frForm, this.lxrForm, this.accountForm);
          //对数据进行处理，用户名和密码去空格
          oData.loginName = oData.loginName.replace(/\s*/g, '');
          oData.password = this.encode64(oData.password.replace(/\s*/g, ''))
          oData.confirmPassword = this.encode64(oData.confirmPassword.replace(/\s*/g, ''));
          var sAttachIds = '';
          if (this.baseForm.files && this.baseForm.files.length > 0) {
            for (let i = 0; i < this.baseForm.files.length; i++) {
              let row = this.baseForm.files[i];
              sAttachIds = sAttachIds + row.id + ',';
            }
          }
          sAttachIds = sAttachIds.substr(0, sAttachIds.length - 1);
          var oParams = {attachIds: sAttachIds};
          this.$api.deptExtend.registerDeptExtend(oData, oParams).then((res) => {
            if (res.code !== 200) {
              this.$message({
                message: res.msg,
                type: 'error',
              });
            } else {
              this.$message({
                message: '注册成功,等待入会审核',
                type: 'success',
                duration: 5000,
                showClose: true,
              });
              Cookies.set('token', res.data); // 放置token到Cookie
              sessionStorage.setItem('user', oData.account); // 保存用户到本地会话
              this.$api.user.findUserInfo().then((res) => {
                let user = res.data;
                this.$store.commit('setDeptId', user['deptId']);
                this.$store.commit('menuRouteLoaded', false); // 要求重新加载导航菜单
                this.$router.push('/');  // 登录成功，跳转到主页
              });
            }
          }).catch((res) => {
            this.$message({
              message: res.message,
              type: 'error',
            });
          });

        } else {
          return false;
        }
      });
    },
    cancel() {//返回登录页面
      this.$router.push('/');
    },
    bindCA() {
      this.CA = new CA();
      this.CA.initService().then((str) => {
        this.passwordDlgVisible = true;
      }).catch(error => {
        this.$message.error('未检测到CA锁，请插入CA锁!');
      });
    },
    getCAInfo: function() {
      this.passwordDlgVisible = true;
    },
    btnOkClick: function(str) {
      console.log("点击了确定")
      this.CA.getCertInfo(str).then(res => {
        this.baseForm['name'] = res['cerUniversalName'];
        this.baseForm['caCode'] = res['cerOID'];
        this.baseForm['tyshxydm'] = res['shxydm'];
        this.passwordDlgVisible = false;
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    encode64(input) {
      const keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '='
      let output = ''
      let chr1; let chr2; let chr3 = ''
      let enc1; let enc2; let enc3; let enc4 = ''
      let i = 0
      do {
        chr1 = input.charCodeAt(i++)
        chr2 = input.charCodeAt(i++)
        chr3 = input.charCodeAt(i++)
        enc1 = chr1 >> 2
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
        enc4 = chr3 & 63
        if (isNaN(chr2)) {
            enc3 = enc4 = 64
        } else if (isNaN(chr3)) {
            enc4 = 64
        }
        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) +
            keyStr.charAt(enc3) + keyStr.charAt(enc4)
        chr1 = chr2 = chr3 = ''
        enc1 = enc2 = enc3 = enc4 = ''
      } while (i < input.length)
      return output
    }
  },

  mounted() {

  },
};
</script>

<style scoped>
.main {
  text-align: left;
}

.content {
  width: 1000px;
  margin: 0 auto;
}

.inline > div {
  display: inline-block;
}

.el-col .el-cascader {
  width: 100%;
}

.operations {
  text-align: center;
  padding-bottom: 30px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.regTip {
  color: gray;
  margin-left: 10px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue